import React, { useEffect, useState } from "react";
import * as s from "./index.module.scss";
import BG from "../../../images/Hero/bg.png";
import Side from "../../../images/Hero/side.png";
import HeroContent from "./_HeroContent";
import { PrismicNextImage } from "@prismicio/next";

const Hero = ({
  opacity = true,
  backgroundImage = { BG },
  backgroundImageMobile,
  backgroundImageTab,
  sideImage = { Side },
  sideImageMobile,
  caption = "",
  title = "Luxury Watches Title",
  description = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  features = ["Key feature one", "Key feature two", "Key feature three"],
  viewMoreLink = "",
  homepage = false,
  visibility = false,
  bgColor = "",
  page = "",
  normalHeading = true,
}) => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    // Set initial window width
    handleResize();
    // Attach event listener for window resize
    window.addEventListener("resize", handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className={s.hero}>
      <div
        className={`${s.hero_wrapper} ${opacity ? "" : s.hero_without_opacity}`}
      >
        {bgColor ? (
          <div
            className={s.background_with_side_image}
            style={{
              width: windowWidth < 768 ? "150%" : "100%",
              height: "100%",
            }}
          >
            <div
              style={{
                backgroundColor: bgColor,
                width: "100%",
                height: "100%",
              }}
            ></div>
          </div>
        ) : windowWidth < 768 && backgroundImageMobile ? (
          <div className={s.background_with_side_image}>
            <PrismicNextImage
              field={backgroundImageMobile}
              fallbackAlt=""
              className={opacity ? "" : s.no_opacity}
              width={windowWidth}
              height={windowWidth}
              loading={"eager"}
              priority
            />
          </div>
        ) : windowWidth < 1024 && backgroundImageTab ? (
          <div className={s.background_image_container}>
            <PrismicNextImage
              field={backgroundImageTab}
              fallbackAlt=""
              className={opacity ? "" : s.no_opacity}
              width={windowWidth}
              height={windowWidth}
              loading={"eager"}
              priority
            />
          </div>
        ) : (
          <div className={s.background_image_container}>
            <PrismicNextImage
              field={backgroundImage}
              fallbackAlt=""
              className={opacity ? "" : s.no_opacity}
              width={windowWidth}
              height={windowWidth}
              loading={"eager"}
              priority
            />
          </div>
        )}
        <div className={s.hero_content_wrapper}>
          <HeroContent
            caption={caption}
            title={title}
            description={description}
            features={features}
            sideImage={sideImage}
            sideImageMobile={sideImageMobile}
            viewMoreLink={viewMoreLink}
            homepage={homepage}
            visibility={visibility}
            page={page}
            normalHeading={normalHeading}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
